// extracted by mini-css-extract-plugin
export default {"text_wrapper":"text_wrapper__7d8f0d6f","textarea":"textarea__7d8f0d6f","count":"count__7d8f0d6f"};